import React from 'react';
import styles from './css/index.module.scss';

function Terms() {
  return (
    <div className={styles.aboutWrapper}>
      <div id="dev_page_content_wrap" className=" ">
        <div className="dev_page_bread_crumbs" />
        <h1 id="dev_page_title">Terms of Service</h1>

        <div id="dev_page_content">
          <p>
            These Terms are an agreement between you and Fragment Corp. (the “Company”) a
            company registered according to the laws of the Republic of Seychelles with company registration number
            221287. For the purposes of this document, ‘we’, ‘us’ and ‘our’ refers to Fragment Corp., ‘Telegram’ refers
            to Telegram Messenger Inc. and ‘you’ refers to you, the user.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#1-introduction"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="1-introduction"
            />
            1. Introduction
          </h3>
          <p>
            Fragment (the “Platform”) is a non-custodial free auction platform fully owned and operated by Company.
            Platform allows anyone to securely and anonymously purchase digital
            <strong>
              collectible
              entities
            </strong>
            {' '}
            via NFT-like smart contracts, purchase or give away Telegram Premium subscriptions, deposit funds to publish
            {' '}
            <a
              href="https://ads.telegram.org/"
            >
              Telegram Ads
            </a>
            , and withdraw
            {' '}
            <a
              href="https://telegram.org/blog/monetization-for-channels"
            >
              content creator rewards
            </a>
            . All
            transactions rely on
            {' '}
            <a href="https://en.wikipedia.org/wiki/Telegram_Open_Network">TON</a>
            ,
            a
            <strong>decentralized</strong>
            , scalable and
            <strong>open-source</strong>
            {' '}
            blockchain network technology
            initially developed by
            {' '}
            <a href="https://telegram.org">Telegram</a>
            .
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#1-1-account-and-authentication"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="1-1-account-and-authentication"
            />
            1.1. Account and Authentication
          </h4>
          <p>
            Purchased collectibles are linked to the unique TON wallet of their new owner – they are not directly
            tied to accounts on any other platform, including those which may directly or indirectly integrate with
            Platform. After purchasing a collectible you are solely responsible for the safekeeping of any relevant
            credentials, hardware, or backups that granted you access to your TON wallet.
          </p>
          <p>
            Company does not have access to your TON wallet and does not store any information which could trace it
            back to you personally or to any of your accounts. Consequently, it cannot restore the wallet or any of
            the collectibles contained therein if you lose your credentials.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#1-2-ownership"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="1-2-ownership"
            />
            1.2. Ownership
          </h4>
          <p>
            Purchased collectibles are securely stored in the TON blockchain’s immutable ledger. Ownership is
            therefore permanent and cannot be revoked, even by Company – consequently, all purchases are
            non-refundable. Owners may choose to privately sell their collectibles or auction them to the public at
            any time.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#1-3-taxes-fees-and-local-laws"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="1-3-taxes-fees-and-local-laws"
            />
            1.3. Taxes, Fees and Local Laws
          </h4>
          <p>
            Company operates with cryptocurrencies – regulations on this payment method may differ depending on your
            country of residence. You are solely responsible for all applicable taxes or fees and you must comply with
            relevant local laws.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#1-4-availability"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="1-4-availability"
            />
            1.4. Availability
          </h4>
          <p>
            Company may limit which countries it operates in and which of its particular services are available in
            certain countries at any time and without notice, in response to legal or regulatory requirements,
            technical limitations or other factors. Company will not compensate you for any losses incurred as a
            result of such changes.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#2-available-entities"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="2-available-entities"
            />
            2. Available Entities
          </h3>
          <p>
            Generally, entities currently available for purchase on Platform have a direct association with an
            element or service in the Telegram ecosystem. Collectible holders are free to either sell them to
            interested parties through Platform or any other third-party platform, keep them dormant indefinitely or
            use them on Telegram or on any service able and willing to provide associated benefits.
          </p>
          <p>
            Platform currently includes collectible Telegram usernames and anonymous numbers for sale and auction.
            Additionally, it facilitates the purchase of Telegram Premium subscriptions and Telegram Ads, pursuant to
            the terms set out below.
          </p>
          <p>
            Other elements, collectibles, subscriptions or services could potentially be listed in the future.
            Company reserves the right to auction or sell new entities or remove entities and services from the
            Platform at any time without notice.
          </p>
          <p>
            The temporary or permanent removal of an entity from Platform has no bearing on previously purchased
            collectibles and past transactions – where applicable, ownership is permanent.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#3-agency-of-purchased-collectibles">
              <i
                className="anchor-icon"
              />
            </a>
            {' '}
            <a className="anchor" name="3-agency-of-purchased-collectibles" />
            3.
            Agency of Purchased Collectibles
          </h3>
          <p>
            Collectibles purchased on Platform are stored in the decentralized TON immutable ledger and exist
            independently of their shared functionality and integration with Telegram or any other platform.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#3-1-integration-with-telegram"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="3-1-integration-with-telegram"
            />
            3.1. Integration with Telegram
          </h4>
          <p>
            When you purchase a collectible or service on Platform, Telegram will provide you with the perks and
            functionalities associated with it, however, Company makes no guarantee that this will be the case in
            perpetuity. Purchasing an entity on Platform does not entitle owners to any form of refund in case any
            company which integrates it is no longer able or willing to provide its functionalities, either partially
            or in full.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#3-2-relevance-agency-and-purpose">
              <i
                className="anchor-icon"
              />
            </a>
            {' '}
            <a className="anchor" name="3-2-relevance-agency-and-purpose" />
            3.2.
            Relevance, Agency and Purpose
          </h4>
          <p>
            Company cannot predict or ensure the future absence of new features or events which would render
            previously purchased entities less effective or arguably obsolete. Consequently, by purchasing an entity
            you agree that it is sold “as is” – Company makes no guarantee as to its continued usefulness, inherent
            value, perceived prestige and profitability or lack thereof.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#3-3-range-of-effective-benefits"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="3-3-range-of-effective-benefits"
            />
            3.3. Range of Effective Benefits
          </h4>
          <p>
            Company offers no guarantee that platforms which integrate collectibles will do so free of charge. Any
            platform can integrate collectibles as it sees fit and their implementation may change at any time.
            Platforms are free to include additional fees and introduce extensions or restrictions on the range of
            benefits and features provided by each entity.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#4-telegram-ads"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="4-telegram-ads"
            />
            4. Telegram Ads
          </h3>
          <p>
            Company facilitates the purchase of Telegram Ads, which can be set up by eligible advertisers via the
            {' '}
            <a
              href="https://ads.telegram.org/"
            >
              Telegram Ad Platform
            </a>
            {' '}
            in accordance with the
            {' '}
            <a
              href="https://ads.telegram.org/guidelines"
            >
              Telegram Ad Policies and Guidelines
            </a>
            .
          </p>
          <p>
            Platform serves solely as a means of funding your advertiser account, allowing you to use TON to purchase
            sponsored messages. Company makes no guarantee as to the inherent value of the ads you purchase, including
            their efficacy, profitability or fitness for any particular purpose.
            {' '}
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#4-1-third-party-advertisement-guidelines">
              <i
                className="anchor-icon"
              />
            </a>
            {' '}
            <a
              className="anchor"
              name="4-1-third-party-advertisement-guidelines"
            />
            4.1. Third-party
            Advertisement Guidelines
          </h4>
          <p>
            Fragment has no access to the contents of the ads you publish on Telegram, and any disputes as to the
            compliance of said ads with the
            {' '}
            <a href="https://ads.telegram.org/guidelines">
              Telegram Ad Policies and
              Guidelines
            </a>
            {' '}
            are to be resolved solely between you and Telegram, in accordance with applicable terms.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#5-rewards-for-telegram-content-creators">
              <i
                className="anchor-icon"
              />
            </a>
            {' '}
            <a
              className="anchor"
              name="5-rewards-for-telegram-content-creators"
            />
            5. Rewards for
            Telegram Content Creators
          </h3>
          <p>
            Owners of Telegram channels that are eligible for
            {' '}
            <a
              href="https://telegram.org/blog/monetization-for-channels"
            >
              Telegram’s content creator rewards
              program
            </a>
            {' '}
            may use Platform to withdraw their rewards.
          </p>
          <p>
            The currency and means of payment for such rewards will be determined by Fragment in its sole
            discretion.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#5-1-rewards-for-ads"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="5-1-rewards-for-ads"
            />
            5.1. Rewards for Ads
          </h4>
          <p>
            Your reward is independently calculated by Telegram in connection with the number of valid impressions of
            sponsored messages displayed in eligible channels you own, subject to the Telegram
            {' '}
            <a
              href="https://telegram.org/tos/content-creator-rewards"
            >
              Terms of Service for Content Creators
            </a>
            .
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#5-2-withdrawal"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="5-2-withdrawal"
            />
            5.2. Withdrawal
          </h4>
          <p>
            Company facilitates the withdrawal of Advertisement Revenue Sharing rewards by allowing users to connect
            their Telegram account and TON wallet to Platform. By default, rewards are issued as Toncoin (TON), which
            can be withdrawn to the wallet you connect to Platform. When you withdraw your reward, the transaction is
            stored in the decentralized, immutable TON ledger and cannot be undone – it is your responsibility to
            ensure that you connect the correct wallet to Platform before withdrawal.
          </p>
          <p>
            In some countries, rewards could be paid in alternative ways, such as stablecoins or other means of
            payments, at the sole discretion of Fragment. Company only facilitates reward withdrawal, as available
            based on existing regulatory conditions.
          </p>
          <p>
            Company may, either temporarily or permanently, remove your ability to withdraw rewards, for reasons
            including but not limited to violations of these Terms, as well as regulatory changes or other
            considerations.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#5-2-account-management"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="5-2-account-management"
            />
            5.2. Account Management
          </h4>
          <p>
            Transactions on the TON blockchain cannot be reversed. When accepting Advertisement Revenue Sharing
            rewards, make sure that the destination wallet is meant for the relevant cryptocurrency and matches your
            intended recipient.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#6-telegram-stars"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="6-telegram-stars"
            />
            6. Telegram Stars
          </h3>
          <p>
            Bot developers and
            {' '}
            <a href="https://telegram.org/tos/content-creator-rewards">content creators</a>
            {' '}
            who
            received Telegram Stars in exchange for products, services, content or other perks may use Platform to
            obtain cryptocurrency based on the amount of Stars in their balance.
          </p>
          <p>
            The type of cryptocurrency issued for such rewards will be determined by Fragment in its sole discretion
            and may change at any time without notice.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#6-1-rewards-for-stars"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="6-1-rewards-for-stars"
            />
            6.1. Rewards for Stars
          </h4>
          <p>
            Your reward is calculated by Telegram, independently of Fragment, based on the number of Stars in your
            balance and the equivalent USD value of each Star as determined by Telegram in its sole discretion and
            relayed to us, subject to Telegram’s
            {' '}
            <a href="https://telegram.org/tos/bot-developers">
              Terms of Service
              for Bot Developers
            </a>
            {' '}
            and
            {' '}
            <a href="https://telegram.org/tos/content-creator-rewards">
              Creator
              Rewards
            </a>
            . To calculate the Toncoin equivalent of your rewards, Company uses the market conversion
            rate from https://coinmarketcap.com/currencies/toncoin, updated approximately every 5
            minutes.
          </p>
          <p>
            Company may temporarily or permanently remove your ability to receive Star rewards, for reasons including
            but not limited to violations of these Terms, as well as regulatory changes or other considerations.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#6-2-account-management"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="6-2-account-management"
            />
            6.2. Account Management
          </h4>
          <p>
            Company facilitates rewards for Telegram Stars by allowing users to connect their Telegram account and
            TON wallet to Platform. When you claim your reward, the transaction is stored in a decentralized,
            immutable blockchain ledger and cannot be undone – it is your responsibility to ensure that you connect
            the correct wallet to Platform before proceeding.
          </p>
          <p>
            Transactions on Platform cannot be reversed. When accepting rewards for Stars, make sure that the
            destination wallet is meant for the relevant cryptocurrency and matches your intended recipient.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#7-paid-subscriptions"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="7-paid-subscriptions"
            />
            7. Paid Subscriptions
          </h3>
          <p>
            Company facilitates the purchase of certain paid subscriptions which users can apply to their own
            accounts on third-party platforms, or give away to others at their discretion. We make no guarantee as to
            the inherent value, profitability or continued availability and support for any subscription sold on
            Platform.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#7-1-telegram-premium"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="7-1-telegram-premium"
            />
            7.1. Telegram Premium
          </h4>
          <p>
            Currently, Platform supports the purchase of Telegram Premium subscriptions. When purchasing a Telegram
            Premium subscription, either for your own account or as part of a larger
            {' '}
            <a
              href="https://telegram.org/tos/eu#7-8-giveaways-in-channels"
            >
              giveaway
            </a>
            , you agree to be bound by
            the Telegram
            {' '}
            <a href="https://telegram.org/tos">Terms of Service</a>
            {' '}
            and, by extension,
            {' '}
            <a
              href="https://telegram.org/tos#terms-of-service-for-telegram-premium"
            >
              Terms of Service for Telegram
              Premium
            </a>
            .
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#8-compliance-with-the-terms"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="8-compliance-with-the-terms"
            />
            8. Compliance with the Terms
          </h3>
          <p>
            Collectibles purchased through Platform exist independently of Telegram and you are welcome to freely
            integrate them into your own platform, however, their implementation or usage within the Telegram
            ecosystem is fully contingent on your compliance with its Terms of Service. Using these collectibles on
            other platforms may be further subject to the third party's terms as agreed between you and the third
            party.
          </p>
          <h4>
            {' '}
            <a className="anchor-link" href="#8-1-unilateral-removal"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="8-1-unilateral-removal"
            />
            8.1. Unilateral Removal
          </h4>
          <p>
            Fragment cannot guarantee that Telegram will not restrict or delete an account if it violates the
            Telegram ToS or the laws of certain countries. Additionally, the account owner may intentionally or
            mistakenly delete their Telegram account at any time.
          </p>
          <p>
            If that deleted, restricted or otherwise inaccessible account were using a collectible username or phone
            number, it may potentially become impossible to link such a username or phone number to that Telegram
            account. If it were using a different type of collectible, the deletion of the account would still not
            revoke ownership over the collectible, however, it may at times prevent collectibles from further
            interaction with the Telegram ecosystem. The same generally holds true for any platform or service
            implementing or assigning entities sold by Platform, but Company does not guarantee that this will always
            be the case.
          </p>
          <p>
            Furthermore, that account may permanently lose access to all non-collectible entities purchased from or
            made available by Platform, including but not limited to unwithdrawn
            {' '}
            <a
              href="https://telegram.org/blog/monetization-for-channels"
            >
              content creator rewards
            </a>
            , unspent
            Telegram
            {' '}
            <a href="https://ads.telegram.org/">advertising</a>
            {' '}
            funds and its active premium subscription, if
            applicable. For clarity, Platform cannot facilitate the withdrawal of positive reward balances accrued by
            Telegram accounts that have since been terminated, and such rewards are to be considered forfeit.
          </p>
          <p>
            Generally, should any collectible, entity, subscription, service, or utility purchased on or provided by
            Platform lose its inherent value, or otherwise become partially or fully inaccessible as a result of your
            account being banned or deleted from Telegram (both if by Telegram and by yourself), Company will not be
            liable and you will not be compensated for your loss.
          </p>
          <h3>
            {' '}
            <a className="anchor-link" href="#8-changes-to-these-terms"><i className="anchor-icon" /></a>
            {' '}
            <a
              className="anchor"
              name="8-changes-to-these-terms"
            />
            8. Changes to these Terms
          </h3>
          <p>
            We reserve the right to revise and modify these terms at our sole discretion. While we do not anticipate
            frequent changes, you should check this page frequently to stay updated on the latest version.
          </p>
          <p>We will post a summary of any significant changes under this section.</p>
        </div>

      </div>
    </div>
  );
}

export default Terms;
